(ns frontend.ux-overhaul.view-configuration.events
  (:require
   [re-frame.core :refer [reg-event-db reg-event-fx]]
   [frontend.routing :as routing]
   [frontend.ux-overhaul.view-configuration.common :refer [view-configuration-path]]
   [frontend.db]))

(reg-event-fx
 :start-view-configuration
 (fn [{:keys [db]} [_ {:keys [entity-type view-configuration]}]]
   (let [from-page (routing/routed-view-id)
         entity-type (or entity-type :entity.type/task)
         config (merge view-configuration
                       {:from-page   from-page
                        :entity-type entity-type})
         new-db (assoc-in db view-configuration-path config)]
     {:db new-db
      ::routing/old-routing {:path-args [:view-configuration]}})))

(reg-event-db
 ::update-view-configuration-field
 (fn [db [_ {:keys [path value]}]]
   (let [path (concat view-configuration-path path)]
     (-> db
         (assoc-in path value)
         (assoc-in (concat view-configuration-path [:unsaved-changes?]) true)))))

(reg-event-fx
 ::save-view-configuration
 (fn [{:keys [db]}]
   (let [view-configuration (get-in db view-configuration-path)
         from-page (:from-page view-configuration)

         entity-type (:entity-type view-configuration)

         view-configuration (dissoc view-configuration :from-page :entity-type :unsaved-changes?)

         new-db (-> db
                    (assoc-in [:view-configuration entity-type] view-configuration)
                    (assoc-in view-configuration-path nil))]
     {:db new-db
      :view-configuration-actions/save! {:entity-type        entity-type
                                         :view-configuration view-configuration}
      ::routing/old-routing {:path-args [from-page]}})))
